import React, { useEffect, useRef } from 'react';
import { Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../Shared/GlobalContext/ThemeContext';

const { TextArea } = Input;

const FooterInput = ({
    message,
    setMessage,
    handleKeyDown,
    updateSelectionFromEvent,
    isRecording,
    pendingVoice,
    textAreaRef,
    focusInputRef,
    mobileButtonStyle,
    buttonStyle, // New prop
    beautifying,
    runBeautifyMessage,
    iconSize
}) => {
    const { t } = useTranslation();
    const { isDarkMode } = useTheme();

    const finalButtonStyle = buttonStyle || mobileButtonStyle;

    // Expose a focus method to parent via ref
    useEffect(() => {
        if (!focusInputRef || typeof focusInputRef !== 'object') return;
        focusInputRef.current = () => {
            try {
                const input = textAreaRef.current?.resizableTextArea?.textArea || textAreaRef.current?.input || textAreaRef.current;
                if (input && typeof input.focus === 'function') {
                    input.focus();
                }
            } catch (e) { }
        };
        return () => { focusInputRef.current = null; };
    }, [focusInputRef, textAreaRef]);


    const hasText = !!(message && message.trim());

    if (isRecording || pendingVoice) return null;

    return (
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', position: 'relative', minWidth: 0 }}>
            <TextArea
                ref={textAreaRef}
                value={message}
                onChange={(e) => { setMessage(e.target.value); updateSelectionFromEvent(e); }}
                onSelect={updateSelectionFromEvent}
                onClick={updateSelectionFromEvent}
                onKeyUp={updateSelectionFromEvent}
                onKeyDown={handleKeyDown}
                placeholder={t('start_a_message')}
                rows={1}
                autoSize={message ? { minRows: 1, maxRows: 3 } : false}
                style={{
                    width: '100%',
                    border: 'none',
                    resize: 'none',
                    padding: '6px 0',
                    fontSize: '15px',
                    lineHeight: '20px',
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    color: isDarkMode ? 'rgba(255, 255, 255, 0.85)' : undefined
                }}
            />
        </div>
    );
};

export default FooterInput;
